import { render, staticRenderFns } from "./SetupTemplateProcessesType.vue?vue&type=template&id=186319e3&"
import script from "./SetupTemplateProcessesType.vue?vue&type=script&lang=js&"
export * from "./SetupTemplateProcessesType.vue?vue&type=script&lang=js&"
import style0 from "./SetupTemplateProcessesType.vue?vue&type=style&index=0&id=186319e3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports